import { campaignDraftSchema } from '@schemas/campaign.schema';
import { formOptions } from '@tanstack/react-form';
import { emptyCampaignDraft } from './campaign-modal.shared';

export const campaignFormOptions = formOptions({
  defaultValues: emptyCampaignDraft(),
  validators: {
    onSubmit: campaignDraftSchema,
  },
});
